import Head from "next/head";
import { useRouter } from "next/router";
import { type ReactNode, useEffect, useState } from "react";
import { BotControlProvider } from "@medbillai/app/screens/auth/components/BotControlProvider";
import { LoginScreen } from "@medbillai/app/screens/auth/login";
import { SignUpOnboardingLayout } from "@medbillai/app/screens/sign-up-onboarding/layout.web";
import { FullscreenSpinner, isWeb } from "@medbillai/ui";
import { SlidingLayout } from "../utils/transition/SlidingLayout";
// Adjusted import to resolve error
import type { NextPageWithLayout } from "./_app";
const Page: NextPageWithLayout = () => {
  const router = useRouter();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (router.isReady) {
      setIsLoading(false);
    }
  }, [router.isReady]);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="login.tsx">
        <title>Login</title>
      </Head>
      {isLoading && isWeb !== undefined ? <FullscreenSpinner /> : <LoginScreen />}
    </>;
};

// Direct /login visits keep the single-column login; only the signup handoff
// gets the 2-col hero. The gate is pure URL state (`?variant=signup`), so the
// framing survives a refresh.
const LoginLayout = ({
  children
}: {
  children: ReactNode;
}) => {
  const {
    query
  } = useRouter();
  return <SignUpOnboardingLayout heroImageSrc={query.variant === "signup" ? "/static/onboarding/signup-hero.webp" : undefined} data-sentry-element="SignUpOnboardingLayout" data-sentry-component="LoginLayout" data-sentry-source-file="login.tsx">
      {children}
    </SignUpOnboardingLayout>;
};
Page.getLayout = page => <LoginLayout>
    <SlidingLayout>
      <BotControlProvider>{page}</BotControlProvider>
    </SlidingLayout>
  </LoginLayout>;
export default Page;